import create, { UseStore } from 'zustand';
import { Alert } from '../../core/domain';
export class MipsTuple {
  cptCodeString: string;
  modifierString: string;
  descriptionString: string;
  dxCodes: any[];

  constructor(obj: any = null, dxCodes: any[] = null) {
    if (obj) {
      this.cptCodeString = obj.cptCode;
      this.modifierString = obj.modifier || '';
      this.descriptionString = obj.description;
    }
    this.dxCodes = dxCodes;
  }
}
function sanitizeString(value: string): string {
  return !value ? '' : value == 'null' ? '' : value;
}

class MipsResult {
  name: string;
  tuples: MipsTuple[];
  dxCodes: string[];
  selectedTuple: MipsTuple;
  hasTuples: boolean;
  errorString: string;

  measureId: string;
  checkOkay: boolean;
  instructions: string;

  constructor(obj: any = null) {
    for (let key in obj) {
      const value: any = obj[key];
      switch (typeof value) {
        case 'string':
          this[key] = sanitizeString(value);
          break;
        case 'object':
        case 'boolean':
          this[key] = value;
          break;
      }
    }
    const values: any[] = [];
    this.tuples.forEach((t) => {
      values.push(new MipsTuple(t, this.dxCodes));
    });
    this.tuples = values;
    this.hasTuples = values.length > 0;
  }
}

export type MipsApi = {
  alert: Alert;
  name: string;
  tuples: MipsTuple[];
  dxCodes: string[];
  mipsCompleted: boolean;

  setAlert(a: Alert): void;
};

export function createMipsApi(): UseStore<MipsApi> {
  return create<MipsApi>((set) => ({
    alert: null,
    name: null,
    tuples: [],
    dxCodes: [],
    mipsCompleted: false,
    setAlert: (alert: Alert) => {
      const result = new MipsResult(alert.details);
      console.log('result', result);
      set({
        alert,
        name: 'Measure Id ' + result.measureId + ' - ' + result.name,
        tuples: result.tuples,
        dxCodes: result.dxCodes,
        mipsCompleted: false,
      });
    },
  }));
  /*
       function validateSelected():void {
         selectedResults = new ArrayCollection();
         tuples = [];
         dxCodes = [];
         cptCodes = [];
         diagnosisMasters = [];
         cptMasters = new Dictionary();
         var dxCodesFilter:Object = {};
         for each(var result:MipsResult in results) {
             if (result.selectedTuple) {
                 tuples.push(result.selectedTuple);
                 const cpts:any[] = result.selectedTuple.cptCodeString.split(',');
                 for each(var cpt:string in cpts) {
                     cptCodes.push(cpt);
                 }
                 selectedResults.addItem(result.selectedTuple);
                 for each(var code:string in result.dxCodes) {
                     dxCodesFilter[code] = result.selectedTuple;
                 }
             }
         }
         for (var key:string in dxCodesFilter) {
             dxCodes.push(key);
         }
         mipsCompleted = selectedResults.length > 0;
     }
 }
 */
}

export const mipsApi = createMipsApi();
